// Maps a US/Canada phone number's area code to its metro/region so admins can
// spot phone-vs-location mismatches on suspected fake accounts (e.g. a Chicago
// area code on an account browsing Miami from a Dallas IP). Not exhaustive —
// covers major metros; unknown codes return the bare code with region: null.
const AREA_CODES = {
  // New York
  "212": "New York, NY", "646": "New York, NY", "332": "New York, NY", "917": "New York, NY",
  "718": "New York, NY", "347": "New York, NY", "929": "New York, NY",
  // Florida
  "305": "Miami, FL", "786": "Miami, FL", "954": "Fort Lauderdale, FL", "561": "West Palm Beach, FL",
  "407": "Orlando, FL", "321": "Orlando, FL", "813": "Tampa, FL", "727": "St. Petersburg, FL",
  "941": "Sarasota, FL", "904": "Jacksonville, FL", "850": "Tallahassee, FL", "239": "Fort Myers, FL",
  "352": "Gainesville, FL", "386": "Daytona, FL",
  // Chicago
  "312": "Chicago, IL", "773": "Chicago, IL", "872": "Chicago, IL", "708": "Chicago, IL",
  "630": "Chicago, IL", "847": "Chicago, IL", "224": "Chicago, IL", "331": "Chicago, IL",
  // Texas
  "214": "Dallas, TX", "469": "Dallas, TX", "972": "Dallas, TX", "945": "Dallas, TX",
  "817": "Fort Worth, TX", "682": "Fort Worth, TX", "713": "Houston, TX", "281": "Houston, TX",
  "832": "Houston, TX", "346": "Houston, TX", "512": "Austin, TX", "737": "Austin, TX",
  "210": "San Antonio, TX", "726": "San Antonio, TX", "915": "El Paso, TX",
  // California
  "213": "Los Angeles, CA", "310": "Los Angeles, CA", "323": "Los Angeles, CA", "424": "Los Angeles, CA",
  "818": "Los Angeles, CA", "747": "Los Angeles, CA", "626": "Pasadena, CA", "562": "Long Beach, CA",
  "714": "Orange County, CA", "949": "Orange County, CA", "415": "San Francisco, CA", "628": "San Francisco, CA",
  "510": "Oakland, CA", "408": "San Jose, CA", "669": "San Jose, CA", "619": "San Diego, CA",
  "858": "San Diego, CA", "916": "Sacramento, CA", "650": "Peninsula, CA",
  // Other major metros
  "702": "Las Vegas, NV", "725": "Las Vegas, NV", "775": "Reno, NV",
  "404": "Atlanta, GA", "470": "Atlanta, GA", "678": "Atlanta, GA", "770": "Atlanta, GA",
  "202": "Washington, DC", "703": "Northern VA", "571": "Northern VA", "301": "Maryland", "240": "Maryland",
  "617": "Boston, MA", "857": "Boston, MA", "781": "Boston, MA",
  "206": "Seattle, WA", "425": "Seattle, WA", "253": "Tacoma, WA",
  "602": "Phoenix, AZ", "480": "Phoenix, AZ", "623": "Phoenix, AZ", "520": "Tucson, AZ",
  "303": "Denver, CO", "720": "Denver, CO",
  "215": "Philadelphia, PA", "267": "Philadelphia, PA", "445": "Philadelphia, PA",
  "313": "Detroit, MI", "248": "Detroit, MI",
  "615": "Nashville, TN", "901": "Memphis, TN", "504": "New Orleans, LA", "801": "Salt Lake City, UT",
  "503": "Portland, OR", "971": "Portland, OR", "216": "Cleveland, OH", "614": "Columbus, OH",
  "513": "Cincinnati, OH", "612": "Minneapolis, MN", "651": "St. Paul, MN",
  "704": "Charlotte, NC", "919": "Raleigh, NC", "816": "Kansas City, MO", "314": "St. Louis, MO",
};

export function areaCodeRegion(phone) {
  if (!phone) return null;
  const digits = String(phone).replace(/\D/g, "");
  // Drop a leading US country code so 11-digit numbers still resolve.
  const local = digits.length === 11 && digits[0] === "1" ? digits.slice(1) : digits;
  if (local.length < 10) return null;
  const code = local.slice(0, 3);
  return { code, region: AREA_CODES[code] || null };
}

export default areaCodeRegion;
